import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import getIsMercadoPagoErrorSearchParam from 'utils/mercadopago/getPurchaseErrorSearchParam';
import styles from './PurchaseMercadoPagoError.module.scss';

const PurchaseError: FC = () => {
  const { t } = useTranslation();

  const isMercadoPagoError = getIsMercadoPagoErrorSearchParam();

  return (
    <div className={styles.Container}>
      <Row justify="center">
        <Col>
          <Card className={styles.Card}>
            <WarningOutlined className={styles.WarningIcon} />
            <p className={styles.CardText}>
              {isMercadoPagoError
                ? t('errors.purchase.purchaseMercadoPagoErrorMessage')
                : t('errors.purchase.purchaseErrorMessage')}
            </p>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PurchaseError;
